export default "__VITE_ASSET__1afef1c9__"